"use client";

import React, { useState } from "react";
import { MapPin, Search, Navigation, Building, Tent, Phone, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const locations = [{
  id: "hq",
  title: "Main Operations Hub",
  description: "Sampson HQ: Strategic logistics and heavy machinery dispatch center.",
  type: "office",
  x: 25,
  y: 40
}, {
  id: "departure-1",
  title: "Ready-Mix Dispatch",
  description: "Rapid deployment zone for residential concrete and foundation teams.",
  type: "meeting",
  x: 45,
  y: 65
}];
export default function WhereToFindUs() {
  const [searchQuery, setSearchQuery] = useState("");
  const getIcon = (type: string) => {
    switch (type) {
      case "office":
        return <Building className="size-5 text-primary" />;
      case "meeting":
        return <Navigation className="size-5 text-primary" />;
      case "nature":
        return <Tent className="size-5 text-primary" />;
      default:
        return <MapPin className="size-5 text-primary" />;
    }
  };
  return;
}